<template>
  <v-dialog
    content-class="annotationInfoDialog"
    :value="value"
    @input="(v) => v || close()"
    hide-overlay
    persistent
    no-click-animation
    transition="fade-transition"
    max-width="330px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">アノテーション追加</span>
      </v-card-title>
      <v-card-text class="py-0 px-1">
        <v-container class="pb-0">
          <v-form ref="editAnnotationForm" lazy-validation>
            <v-select
              hide-details="auto"
              v-model="info.type"
              label="異常種類"
              outlined
              dense
              :items="types"
              required
              :rules="[
                (v) => (!!v && !!v.trim()) || '異常種類を選択してください。',
              ]"
              @change="changeType"
            ></v-select>
            <v-select
              :disabled="info.type == 'shadow'"
              hide-details="auto"
              v-model="info.reason"
              label="原因"
              outlined
              clearable
              dense
              :items="reasons"
            ></v-select>
            <h4>座標:</h4>
            <span v-if="info.coordinates"
              >{{ info.coordinates[0] }}, {{ info.coordinates[1] }}</span
            >
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="mt-4">
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="close()">キャンセル</v-btn>
        <v-btn depressed @click.native="onAdd()" color="primary">追加</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { store } from "@/store";

export default {
  name: "AnnotationAddDialog",
  props: ["value", "info"],
  data() {
    return {
      mapviewState: store.state.mapview,
      block: {},
      types: [
        { text: "ホットスポット", value: "cell" },
        { text: "マルチホットスポット", value: "multicell" },
        { text: "クラスタバイパス", value: "cluster" },
        { text: "モジュール異常", value: "module" },
        { text: "ストリング異常", value: "string" },
        { text: "ジャンクションボックス過熱", value: "junction" },
        { text: "ＰＩＤ現象の疑い", value: "pid" },
        { text: "影", value: "shadow" },
      ],
      reasons: [
        { text: "割れ", value: "crack" },
        { text: "堆積物", value: "sediment" },
        { text: "植生", value: "vegetation" },
      ],
    };
  },
  methods: {
    onAdd() {
      if (this.$refs.editAnnotationForm.validate()) {
        this.axios
          .post("/api/annotation/" + this.mapviewState.folderId, this.info)
          .then((response) => {
            store.updateFilterWhenAddOrUpdateAnnotation(this.mapviewState.folderId, this.info);
            this.$emit("added", response.data);
            this.close();
          })
          .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
            this.close();
          });
      }
    },
    close() {
      store.updateOpenDialog(false);
      this.$emit("closed");
      this.$emit("input");
    },
    changeType(){
      if (this.info.type === 'shadow'){
        this.info.reason = null;
      }
    },
  },
  watch: {
    value(value){
      if (value){
        store.updateOpenDialog(true);
      }
    }
  }
};
</script>
